import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationConfigurationModalComponent } from './registration-configuration-modal/registration-configuration-modal.component';

@Component({
  selector: 'app-registration-configuration',
  templateUrl: './registration-configuration.component.html',
  styleUrls: ['./registration-configuration.component.scss']
})
export class RegistrationConfigurationComponent {

  gridApi: GridApi;
  columnDefs;
  operations;
  rowData; 
  selectedRow;   
  constructor(
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal
  ) {

  }

  ngOnInit() { 
    this.columnDefs = [
      {
        "headerName": "Module Name",
        "field": "NAME",
      } 
    ];    
    this.operations = [
      {
        "name": "Edit",
        "id": "edit"
      }
    ];

    this.operations = this.operations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    this.setSummary();
  }

  setSummary() {
    this.summaryService.getRegistrationConfig().subscribe(summary => {
      this.rowData = summary;
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
  if(!this.modalService.hasOpenModals())
   {
     ;
    const ModelRef= this.modalService.open(RegistrationConfigurationModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content={
      heading: 'Edit '+ this.selectedRow['NAME'] ,
      content: {
        id: this.selectedRow['ID'] ,ScreenName :this.selectedRow['NAME'],
        Moduleid:this.selectedRow['MODULE_ID'],
        heading: 'Edit ' }
    }
   }
  
  }

  edit(RecordData: any) {
    const ModelRef = this['self'].modalService.open(RegistrationConfigurationModalComponent, {
      backdrop: false,
      keyboard: false,
      // ignoreBackdropClick: true,
      windowClass: 'modal-lg',
      animation: true
    });
    ModelRef.componentInstance.Content={
        heading: 'Edit '+ RecordData['NAME'] ,
        content: {
          id: RecordData['ID']
        }
      }
  
  ModelRef.content.action.then(result => {
      this['self'].setSummary();
    })
  }
}
